export default {"src":"/_next/static/media/coco-whatsapp.149f34df.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};